.icon {
  display: inline-block;
  text-align: center;
  min-width: 20px;
  padding-right: 2px;
}

.hasText {
  margin-right: 6px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkljb24uc2FzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFO0VBQ0E7RUFDQTtFQUNBOzs7QUFDRjtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLmljb25cbiAgZGlzcGxheTogaW5saW5lLWJsb2NrXG4gIHRleHQtYWxpZ246IGNlbnRlclxuICBtaW4td2lkdGg6IDIwcHhcbiAgcGFkZGluZy1yaWdodDogMnB4XG4uaGFzVGV4dFxuICBtYXJnaW4tcmlnaHQ6IDZweCBcbiJdfQ== */